import Image from "next/image";
import React, { useEffect } from "react";
import ChatButton from "../../components/Chatbot/ChatButton";
import styles from "./Header.module.scss";

type CookieOptions = {
  expires?: number;
  path?: string;
  domain?: string;
  secure?: boolean;
  sameSite?: "Strict" | "Lax" | "None";
};

const tbn_cookie_name = "t_top_bar_notification";

function setCookie(name: string, value: string | boolean, options?: CookieOptions) {
  let expires = "";
  if (options && "expires" in options) {
    const now = new Date();
    now.setDate(now.getDate() + (options.expires ?? 0));
    expires = "; expires=" + now.toUTCString();
  }
  const path = options?.path ? "; path=" + options.path : "";
  const domain = options?.domain ? "; domain=" + options.domain : "";
  const secure = options?.secure ? "; secure" : "";
  const sameSite = options?.sameSite ? "; SameSite=" + options.sameSite : "";

  if (typeof window !== "undefined") {
    document.cookie = `${name}=${value}${expires}${path}${domain}${secure}${sameSite}`;
  }
}

function getCookie(name: string) {
  if (typeof window !== "undefined") {
    const cookieValue = document.cookie
      .split("; ")
      .find((row) => row.startsWith(name))
      ?.split("=")[1];

    return cookieValue;
  }
}

export const Header = function () {
  const [showBanner, setShowBanner] = React.useState(false);

  const handleCloseBtn = () => {
    setCookie(tbn_cookie_name, true, { path: "/", expires: 15 });
    setShowBanner(false);
  };

  useEffect(() => {
    setShowBanner(!getCookie(tbn_cookie_name) ? true : false);
  }, []);

  return (
    <>
      {showBanner && (
        <div className={styles.banner_content}>
          <div className={`trilogyTBN ${styles.trilogyTBN}`}>
            <strong>Save 30% on your online boot camp:</strong> Register for the next available cohort (restrictions
            apply).
          </div>
          <button
            id="close-trilogyTBN"
            type="button"
            className={`close ${styles.banner_btn}`}
            data-dismiss="alert"
            aria-label="Close"
            onClick={handleCloseBtn}
          >
            <span aria-hidden="true">✖</span>
          </button>
        </div>
      )}
      <section>
        <header className={styles.header}>
          <div className={styles.header_logo}>
            <span>
              <Image
                src="https://media.bootcampcdn.com/Columbia/logos/Columbia_Color.svg"
                alt="University of Columbia logo"
                width={400}
                height={35}
              />
            </span>
            <div className={styles.chatButton}>
              <ChatButton
                five9ConfigId="BC | BASE"
                title="Live Chat"
                extraClasses={styles.chatBtn}
                buttonStyle={false}
                expanded={true}
              />
            </div>
          </div>
        </header>
      </section>
    </>
  );
};
